import { MdOutlineComment } from "react-icons/md";

const CommunityUsersTable = ({ data }) => {
    const users = data?.users || [];

    return (
        <div className="px-6 overflow-y-auto flex-grow">
            {users.length > 0 ? (
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    User
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    Email
                                </th>
                                {/* <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    Followers
                                </th>
                                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    Rating
                                </th> */}
                                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    Status
                                </th>
                                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    Membership
                                </th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-100">
                            {users.map((user, index) => (
                                <tr
                                    key={user._id || index}
                                    className="hover:bg-gray-50 transition-colors"
                                >
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">

                                            {user.profileImage ? (
                                                <img
                                                    src={user.profileImage}
                                                    alt={user.fullName || "Profile"}
                                                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                                                />
                                            ) : (
                                                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0">
                                                    {user.fullName?.[0]?.toUpperCase() || "U"}
                                                </div>
                                            )}

                                            <span className="font-medium text-gray-900">
                                                {user.fullName || "N/A"}
                                            </span>
                                        </div>
                                    </td>

                                    <td className="px-6 py-4">
                                        <span className="text-sm text-gray-600">{user.email}</span>
                                    </td>

                                    {/* <td className="px-6 py-4 text-center">
                                        <span className="inline-flex items-center justify-center w-12 h-8 text-blue-700 rounded-lg font-semibold text-sm">
                                            {user.followers}
                                        </span>
                                    </td>

                                    <td className="px-6 py-4 text-center">
                                        <span className="inline-flex items-center justify-center w-12 h-8 text-yellow-700 rounded-lg font-semibold text-sm">
                                            {user.rating}
                                        </span>
                                    </td> */}

                                    <td className="px-6 py-4 text-center">
                                        {user.isActive ? (
                                            <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full">
                                                Active
                                            </span>
                                        ) : (
                                            <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-red-700 bg-red-100 rounded-full">
                                                Inactive
                                            </span>
                                        )}
                                    </td>

                                    <td className="px-6 py-4 text-center">
                                        {user.isJoined ? (
                                            user.isJoined.isAllow ? (
                                                <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full">
                                                    Joined
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-orange-700 bg-orange-100 rounded-full">
                                                    Pending
                                                </span>
                                            )
                                        ) : (
                                            <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-full">
                                                Not Applied
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                    <MdOutlineComment className="text-gray-300 text-6xl mb-4" />
                    <p className="text-gray-500 text-lg">No users found</p>
                </div>
            )}
        </div>
    );
};

export default CommunityUsersTable;